module.exports = __webpack_public_path__ + "static/media/ag.2b9abaa5.svg";